import { render, staticRenderFns } from "./updateScore.vue?vue&type=template&id=7669409e&scoped=true&"
import script from "./updateScore.vue?vue&type=script&lang=js&"
export * from "./updateScore.vue?vue&type=script&lang=js&"
import style0 from "./updateScore.vue?vue&type=style&index=0&id=7669409e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7669409e",
  null
  
)

export default component.exports